export const LicensingModuleQuestions = [
    {
        header: 'CO VŠECHNO LZE LICENCOVAT?',
        answers: [
            {
                content: 'Licencovat je možné předměty práv duševního vlastnictví chráněné průmyslovým právem, ale také know-how.',
                correct: true,
            },
            {
                content: 'Licencovat lze pouze práva, která jsou zapsána v rejstříku Úřadu průmyslového vlastnictví.',
            },
            {
                content: 'Licencovat je možné cokoliv, v podstatě se jedná o nájem.',
            },
        ],
    },
    {
        header: 'CO MÁ OBSAHOVAT LICENČNÍ SMLOUVA?',
        answers: [
            {
                content: 'Zákon č. 89/2012 Sb., občanský zákoník, obsahuje přesné znění licenční smlouvy.',
                correct: true,
            },
            {
                content: 'Každá licenční smlouva se bude lišit – není možné hovořit o nějakém vzoru. Jsou však základní ustanovení, která by měla každá licenční smlouva obsahovat.',
            },
            {
                content: 'Licenční smlouva ani nemusí být, stačí ústní ujednání a stisk ruky.',
            },
        ],
    },
    {
        header: 'PROČ JE DOBRÉ PŘI LICENČNÍM VYJEDNÁVÁNÍ UZAVÍRAT S POTENCIÁLNÍMI PARTNERY DOHODU O MLČENLIVOSTI?',
        answers: [
            {
                content: 'Dohoda o mlčenlivosti je v souladu s právním řádem ČR povinnou součástí každého jednání o duševním vlastnictví.',
            },
            {
                content: 'Dohoda o mlčenlivosti chrání především poskytovatele licence před vyzrazením podstaty ochrany duševního vlastnictví vůči třetím stranám. Důležitá je především u know-how, které je z podstaty chráněno utajením.',
                correct: true,
            },
            {
                content: 'Dohodu o mlčenlivosti není nutné uzavírat – je to zbytečné papírování a administrace navíc. Musíme ji podepsat pouze v případech, kdy o to požádá nabyvatel licence.',
            },
        ],
    },
    {
        header: 'JAK JE STANOVENA LICENČNÍ ODMĚNA?',
        answers: [
            {
                content: 'Stanovení licenční odměny se určí podle statistických údajů zveřejněných Evropským statistickým úřadem v roce předcházejícím uzavření smlouvy.',
            },
            {
                content: 'Výše a způsob stanovení licenční odměny je otázkou smluvního ujednání stran. Většinou je rozdělena na předplatby (downpayment) a pravidelné odměny kalkulované jako procenta z výnosu či obratu (royalties). Výše licenční odměny by měla odrážet podmínky běžné v tržním prostředí.',
                correct: true,
            },
            {
                content: 'Výše licenční odměny se liší v závislosti na tom, zda je nabyvatel veřejný či soukromý subjekt. U veřejných subjektů poskytovatel musí uplatnit nejméně 50% slevu.',
            },
        ],
    },
];
